/**
 * Label for a brewery group row — only breweryGroups.displayName when present.
 *
 * @param {string | null | undefined} displayName
 * @returns {string | null}
 */
export function resolveBreweryGroupDisplayName(displayName) {
  const normalizedDisplayName =
    typeof displayName === 'string' ? displayName.trim() : '';
  return normalizedDisplayName.length > 0 ? normalizedDisplayName : null;
}
